



















import { Component, Vue,Prop } from 'vue-property-decorator'
@Component({})
export default class MdcChip extends Vue{
  @Prop({default:'div'}) tab!:string
  @Prop({default:undefined}) tabindex?:number

  @Prop({default:undefined}) leadingIcon?:string

  @Prop({default:undefined}) trailingIcon?:string
  @Prop({default:false}) selected!:boolean

  @Prop({default:false}) checkmark!:boolean
}
